import MainIcons from '@/icons/main';
import styles from '../../styles.module.css';

type ViewCountProps = {
  count?: string | number;
};

export default function ViewCount({ count }: ViewCountProps) {
  return (
    <span className={styles.viewCount}>
      <MainIcons.EyeOn width="13px" height="13px" fill="var(--gray)" />
      {count && <span>{Number(count)?.toLocaleString()}</span>}
    </span>
  );
}
